import { Component } from '@angular/core';
import { SettingsService } from "../../_services/settings.service";
import { CampaignFixer, Campaign } from "../../_models/crmStats";
import { AlertService } from "../../_services/alert.service";


@Component({
  selector: 'campaigns',
  templateUrl: 'campaigns.html'
})

export class CampaignsComponent {
  hello = "Hello";
  activeSearch = "";
  adSearch = "";
  crmSearch = "";
  camContent = 1;

  campaignFixer: CampaignFixer = new CampaignFixer();

  constructor(public settings: SettingsService,
    private alert: AlertService) {
    let scope = this;
    settings.getCampaigns().subscribe((data: CampaignFixer) => {
      scope.campaignFixer = data;
    });

  }

  checkSettings() {
    var bob = this.campaignFixer;
  }
  edit(cam: Campaign) {
    if (cam.edit) {
      if (cam.CampaignCode == "" && cam.CampaignId == "") {
        this.alert.error("Both fields needed please");
      }
      else {
        cam.edit = false;
        this.settings.updateCampaign(cam).subscribe((res) => {
          console.log(res);
        });
      }
    }
    else {
      cam.tempId = cam.CampaignId;
      cam.tempCode = cam.CampaignCode;
      cam.edit = true;
    }
  }
  cancelCam(cam: Campaign) {
    if (cam.CampaignId == "0") {
      //move back to anotc
      let index = 0;
      let present = true;
      this.campaignFixer.ActiveMappings.some((c) => {
        if (c.CampaignCode==cam.CampaignCode && c.CampaignId==cam.CampaignId) {
          present = true;
          return true;
        }
        index++;
      });
      if (present) {
        this.campaignFixer.ActiveMappings.splice(index, 1);
        this.campaignFixer.AdwordsNotCrm.unshift(cam);
      }
    }
    else if (cam.CampaignCode == "") {
      //move back to cnota
      let index = 0;
      let present = true;
      this.campaignFixer.ActiveMappings.some((c) => {
        if (c.CampaignCode == cam.CampaignCode && c.CampaignId == cam.CampaignId) {
          present = true;
          return true;
        }
        index++;
      });
      if (present) {
        this.campaignFixer.ActiveMappings.splice(index, 1);
        this.campaignFixer.CrmNotAdwords.unshift(cam);
      }
    }
    else {
      cam.CampaignCode = cam.tempCode;
      cam.CampaignId = cam.tempId;
      
    }
    cam.edit = false;
  }
  pusha(cam:Campaign) {
    var index = 0;
    var present = false;
    this.campaignFixer.AdwordsNotCrm.some((c) => {
      if (c.CampaignCode == cam.CampaignCode && c.CampaignId == cam.CampaignId) {
        present = true;
        return true;
      }
      index++;
    })
    if (present) {
      this.campaignFixer.AdwordsNotCrm.splice(index, 1);
      cam.edit = true;
      this.campaignFixer.ActiveMappings.unshift(cam);
    }
  }
  pushc(cam: Campaign) {
    var index = 0;
    var present = false;
    this.campaignFixer.CrmNotAdwords.some((c) => {
      if (c.CampaignCode == cam.CampaignCode && c.CampaignId == cam.CampaignId) {
        present = true;
        return true;
      }
      index++;
    })
    if (present) {
      this.campaignFixer.CrmNotAdwords.splice(index, 1);
      cam.edit = true;
      this.campaignFixer.ActiveMappings.unshift(cam);
    }
  }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/components/campaigns/campaigns.ts